import { Link } from 'react-router-dom';
import './EventCard.css';

// Helper function to strip HTML tags and decode HTML entities
const stripHtml = (html) => {
  if (!html) return '';
  const tmp = document.createElement('div');
  tmp.innerHTML = html;
  return tmp.textContent || tmp.innerText || '';
};

function EventCard({ id, title, date, time, location, description, imageUrl, endDate }) {
  const [day, month, year] = date.split('/').map(Number);
  const dateObj = new Date(year, month - 1, day);
  
  // Check if imageUrl exists and is not an empty string
  const hasImage = imageUrl && imageUrl.trim() !== '';
  
  // Check if event is in the future or ongoing
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  
  // Parse end date if available
  let endDateObj = null;
  if (endDate && endDate.trim() !== '') {
    const [endDay, endMonth, endYear] = endDate.split('/').map(Number);
    endDateObj = new Date(endYear, endMonth - 1, endDay);
  }
  
  // Check if event is ongoing (today or between start and end dates)
  const isOngoing = (dateObj.getTime() === today.getTime()) || 
                   (dateObj < today && endDateObj && endDateObj >= today);
  
  // Check if event is in the future (starts after today)
  const isFutureEvent = dateObj > today;
  
  return (
    <Link to={`/events/${id}`} className="event-card-link">
      <div className="event-card">
        <div className="event-card-container">
          {hasImage ? (
            <div className="event-card-image">
              <img src={imageUrl} alt={title} />
              <div className="image-overlay"></div>
            </div>
          ) : (
            <div className="event-card-image event-card-placeholder">
              <div className="placeholder-content">
                <i className="fa-regular fa-calendar" style={{ fontSize: '4rem', opacity: 0.3 }}></i>
              </div>
              <div className="image-overlay"></div>
            </div>
          )}
          <div className="event-date-badge">
            <div className="event-day">{dateObj.getDate()}</div>
            <div className="event-month">
              {dateObj.toLocaleDateString('it-IT', { month: 'short' })}
            </div>
            <div className="event-year">{dateObj.getFullYear()}</div>
          </div>
          {isOngoing && (
            <div className="event-ongoing-badge">
              In Corso
            </div>
          )}
          {!isOngoing && isFutureEvent && (
            <div className="event-upcoming-badge">
              In Programma
            </div>
          )}
          <div className="event-content-overlay">
            <div className="event-details">
              <h3>{title}</h3>
              <div className="event-info">
                {time && <span className="event-time">🕐 {time}</span>}
                {location && <span className="event-location">📍 {location}</span>}
              </div>
              {description && <p className="event-description">{stripHtml(description)}</p>}
            </div>
            <div className="event-button">Maggiori Info</div>
          </div>
        </div>
      </div>
    </Link>
  );
}

export default EventCard;
